var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.messages),function(m,i){return _c('div',{key:i,staticClass:"toast-inner-container"},[_c('toast',{attrs:{"model":m},on:{"close":function($event){return _vm.onCloseClicked(m)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }